const log = require('../shared_utils/log.js')
const { findTargetById } = require('../shared_utils/find-target.js')
module.exports = function store (state, emitter) {
  emitter.on('drop-to-all', () => {
    // Case 1: Copying an existing glitch application to all other targets
    if (state.selectedGlitchApplicationId && state.selectedTargetId) {
      const fromTarget = findTargetById(state.vm, state.selectedTargetId)
      const glitchApplication = state.glitchApplications.find(
        g => g.id === state.selectedGlitchApplicationId
      )
      const otherSprites = state.vm.runtime.targets.filter(
        t => t.sprite !== fromTarget.sprite
          && t.isOriginal
          && !t.isStage
      )

      emitter.emit('push-history', 'drop-to-all')
      otherSprites.forEach(sprite => {
        emitter.emit(
          'copy-glitch-application',
          fromTarget.id,
          sprite.id,
          glitchApplication.id
        )
      })
      emitter.emit('select-glitch-application', glitchApplication.id)
      log('drop-to-all: copied existing glitch application')
    }
    // Case 2: Applying a new glitch from toolbar to all targets
    else if (state.selectedGlitchId) {
      const allSprites = state.vm.runtime.targets.filter(
        t => t.isOriginal && !t.isStage
      )
      
      emitter.emit('push-history', 'drop-to-all')
      allSprites.forEach(sprite => {
        emitter.emit('apply-glitch', state.selectedGlitchId, sprite.id)
      })
      
      // Select the first applied glitch application
      const firstApplication = state.glitchApplications[state.glitchApplications.length - allSprites.length]

      
      log('drop-to-all: applied new glitch to all targets')
    }
  })
}
